var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.dialogWidth, "max-width": "650px" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.onenter.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "resizable-card",
          class: { "no-select": _vm.resizing },
          style: { height: _vm.dialogHeight + "px" },
        },
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "headline" }, [
                _vm._v("Quest (" + _vm._s(this.rules.name) + ")"),
              ]),
              _c("v-spacer"),
              _c("v-spacer"),
              _c("r-authorize", {
                attrs: {
                  master: _vm.masterAccess,
                  locked: _vm.model.locked,
                  enabled: _vm.model.enabled,
                },
                on: {
                  "update:locked": function ($event) {
                    return _vm.$set(_vm.model, "locked", $event)
                  },
                  "update:enabled": function ($event) {
                    return _vm.$set(_vm.model, "enabled", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticClass: "resizable-card__body" },
            [
              _c(
                "v-col",
                { attrs: { cols: "4", sm: "2", md: "2" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.showPreview()
                        },
                      },
                    },
                    [_vm._v("View JSON")]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-3", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "mb-n5",
                      attrs: { cols: "12", md: "12", sm: "12" },
                    },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "ID:", outlined: "", dense: "" },
                        model: {
                          value: _vm.model.id,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "id",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.id",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Name:" },
                        model: {
                          value: _vm.model.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Key:" },
                        model: {
                          value: _vm.model.key,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "key",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.key",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "3", sm: "3" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Priority", "hide-details": "" },
                        model: {
                          value: _vm.model.priority,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "priority", _vm._n($$v))
                          },
                          expression: "model.priority",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mb-4",
                      attrs: { cols: "12", md: "3", sm: "3" },
                    },
                    [
                      _c("v-checkbox", {
                        attrs: { label: "Master", "hide-details": "" },
                        model: {
                          value: _vm.model.master,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "master", $$v)
                          },
                          expression: "model.master",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "6" } },
                    [
                      _c("r-quest-dropdown", {
                        attrs: {
                          model: _vm.model.chainBack,
                          label: "Chain Back",
                          clearable: true,
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "chainBack", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-expansion-panels",
                    [
                      _c(
                        "v-expansion-panel",
                        [
                          _c("v-expansion-panel-header", {
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ open }) {
                                  return [
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-top": "5px",
                                            },
                                          },
                                          [_vm._v("Properties")]
                                        ),
                                        _c("v-spacer"),
                                        _c("v-fade-transition", [
                                          open
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    display: "inline-flex",
                                                  },
                                                },
                                                [
                                                  _c("v-divider", {
                                                    staticClass: "mx-1",
                                                    attrs: { vertical: "" },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c(
                                "v-row",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "6", sm: "6" } },
                                    [
                                      _c("r-quest-show", {
                                        attrs: {
                                          model: _vm.model.showOnAvailable,
                                          label: "Show on available:",
                                        },
                                        on: {
                                          "update:model": function ($event) {
                                            return _vm.$set(
                                              _vm.model,
                                              "showOnAvailable",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "6", sm: "6" } },
                                    [
                                      _c("r-quest-show", {
                                        attrs: {
                                          model: _vm.model.showOnComplete,
                                          label: "Show on complete:",
                                        },
                                        on: {
                                          "update:model": function ($event) {
                                            return _vm.$set(
                                              _vm.model,
                                              "showOnComplete",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "6", sm: "6" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Delay on available:",
                                          "hide-details": "",
                                        },
                                        model: {
                                          value: _vm.model.delayOnAvailable,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.model,
                                              "delayOnAvailable",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "model.delayOnAvailable",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "6", sm: "6" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Delay on complete:",
                                          "hide-details": "",
                                        },
                                        model: {
                                          value: _vm.model.delayOnComplete,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.model,
                                              "delayOnComplete",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "model.delayOnComplete",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("r-reward-panel", {
                        attrs: { model: _vm.model.reward, title: "Rewards" },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "reward", $event)
                          },
                        },
                      }),
                      _c("r-guard-panel", {
                        attrs: {
                          model: _vm.model.guard,
                          title: "Guard Config",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "guard", $event)
                          },
                        },
                      }),
                      _c("r-trigger-panel", {
                        attrs: {
                          items: _vm.model.triggersAvailable,
                          title: "Triggers - Available",
                        },
                        on: {
                          "update:items": function ($event) {
                            return _vm.$set(
                              _vm.model,
                              "triggersAvailable",
                              $event
                            )
                          },
                        },
                      }),
                      _c("r-trigger-panel", {
                        attrs: {
                          items: _vm.model.triggersComplete,
                          title: "Triggers - Complete",
                        },
                        on: {
                          "update:items": function ($event) {
                            return _vm.$set(
                              _vm.model,
                              "triggersComplete",
                              $event
                            )
                          },
                        },
                      }),
                      _c("r-money-panel", {
                        attrs: {
                          model: _vm.model.priceComplete,
                          title: "Price - Complete",
                          ticket: true,
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "priceComplete", $event)
                          },
                        },
                      }),
                      _c(
                        "r-panel",
                        { attrs: { title: "Map Group" } },
                        [
                          _c("r-map-group-dropdown", {
                            attrs: { model: _vm.model.mapGroup },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(_vm.model, "mapGroup", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "r-panel",
                        { attrs: { title: "Map Kind" } },
                        [
                          _c("mapkind-dropdown", {
                            attrs: { clearable: true },
                            model: {
                              value: _vm.model.mapKind,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "mapKind", $$v)
                              },
                              expression: "model.mapKind",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "resizable-card__actions" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              !_vm.lockedAssess || _vm.masterAccess
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: { click: _vm.save },
                    },
                    [_vm._v(" Save ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("div", {
            staticClass: "resize-handle",
            on: { mousedown: _vm.startResize },
          }),
          _c("r-preview-dialog", { ref: "preview-dialog" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }